import React, { Component } from "react";
import { Icon, Button } from 'semantic-ui-react';
import { withRouter} from 'react-router-dom';


class PanelHeader extends Component {

  //state = { open: false, showAll: false };

  constructor(props) {
      super(props)
      this.state = { open: false, showAll: false };
      this.key = this.props.title.toLowerCase().replace(" ", "");
      this.type = this.props.type.toLowerCase().replace(" ", "");
      //window.addEventListener("hashchange", this.handleHashChange, false);
  }

  // handleHashChange = () => {
  //   this.setState({ open: (window.location.hash === "#/"+this.key) })
  // }


  toggle = () => {
    
    this.setState({ open: !this.state.open })
    // const params = new URLSearchParams(props.location.search); 
    // const panel = params.get('panel');
    // console.log("panel: "+ panel);
    
    if (!this.state.open) {
      // document.location.hash = this.key;
      
      const params = new URLSearchParams(document.location.search); 
      params.set('panel', this.key);
      //this.props.history.push(window.location.pathname + "?" + params.toString());
      //window.history.replaceState(window.location.pathname + "?" + params.toString());

      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+params.toString()+window.location.hash;
      //alert(newurl);
      window.history.replaceState({path:newurl},'',newurl);
      if (window.localStorage) {
        localStorage.setItem("activePanel", this.key);
      }
    } else {
      this.setState({ open: false });
    }
  }

  componentDidMount() {
    if (this.props.state === true)
      this.toggle();
  }

  render() {
    const open = this.state.open;
    const showAll = this.state.showAll;
    const panels = this.props.panels || []
    
    let truncatedPanels;
    if (showAll) {
      truncatedPanels = panels;
    } else {
      truncatedPanels = panels.slice(0, 4)
    }

    return (
      <div className={"accordion panel-header " + this.props.className}>
        <div className={"title " + (open ? "active" : null)} style={{ backgroundColor: open ? this.props.accent : "white" }}>
          <div onClick={this.toggle} className="thumb">
            <div className="text">{this.props.title}</div>
          </div>
          <div onClick={this.toggle} className="desc" style={{ borderLeftColor: this.props.accent }}>
            <span className="text" style={{ color: open ? "white" : "inherit" }}>{this.props.desc}</span>
          </div>
          <div onClick={this.toggle} className="arrow">
            <div className="icon" style={{ transform: open ? "rotate(90deg)" : "inherit" }}>
              <Icon name='chevron right' />
            </div>
          </div>
        </div>

        {open &&
          <div>
            <div className="content active">
              {this.props.children({ truncatedPanels })}
            </div>
            <div className="content-footer">
              {showAll ? <Button onClick={this.truncatePanels} style={{ marginLeft: "auto", marginRight: "auto", display: "block" }}>{this.props.showButton.showLess}</Button> : <Button onClick={this.showAllPanels} style={{ marginLeft: "auto", marginRight: "auto", display: "block" }}>{this.props.showButton.showMore}</Button>}
            </div>
          </div>
        }
      </div>
    );
  }

  showAllPanels = () => this.setState({ showAll: true })
  truncatePanels = () => this.setState({ showAll: false })
};

export default withRouter(PanelHeader);



// WEBPACK FOOTER //
// ./src/components/PanelHeader/index.js